<app-data-table [data]="allData" *ngIf="!editCompensation"
[displayedColumns]="['employeeId','employeeName','currencyType','effectiveDate']"
[headerLabels]="['Employee Id','Employee Name','Currency Type','Effective Date']"
[filterColumns]= "['employeeId','employeeName','currencyType']"  
[multipleFilter]="multipleFilterArray"  (filteredArray)="searchFilterData($event)"
 fromWhere="compensation" (tableRowClick)="selectedRow($event)" [searchBar]="true" [filterDataArray]="filterKeys">
</app-data-table>

<app-compensation-edit *ngIf="editCompensation" [getEmployeeId]="passEmployeeId" (emitBack)="editCompensation = $event; getEmployees()"></app-compensation-edit>
